'use strict';
import FontAwesome from 'react-fontawesome';
import React from 'react';
import SupportInfo from '../SupportInfo.jsx';

/**
 * Displays a warning message if an unrecoverable error occurred, and provides
 * additional information for how end-users could obtain support.
 * 
 * @export
 * @class Error
 * @extends {React.Component}
 */
export default class Error extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return <div className="row">
            <div className="col-md-12">
                <h4>
                    <FontAwesome name="warning" /> Problem Detected
                </h4>

                <p>
                    There was a problem while trying to
                    complete your request. Please try again in
                    a few minutes. If you continue to see this message, let 
                    us know.
                </p>

                <SupportInfo />

                <p>
                    <a href="/resetpwd" className="btn btn-warning">
                        <i className="fa fa-refresh"></i> Start Over
                    </a>
                </p>
            </div>
        </div>;
    }

}


// WEBPACK FOOTER //
// ./src/react/views/Error.jsx